/**
 * Entreprises émettrices de la fiche CERFA 15497*04 (issue #138, décision du
 * 24/10/2026). Une entreprise qui travaille aussi sous une autre raison sociale,
 * ou en sous-traitance pour un donneur d'ordre, les enregistre une fois dans
 * Mon entreprise › Fluides et CERFA ; le technicien choisit ensuite dans la
 * liste. La fiche COPIE l'identité choisie (raison sociale, adresse, SIRET,
 * attestation) : modifier la liste ne réécrit jamais une fiche existante.
 */
import { z } from 'zod';

export const CERFA_ISSUERS_MAX = 10;

/** SIRET : 14 chiffres, espaces de saisie tolérés. */
export const siretDigits = (value: string): string => value.replace(/\s/g, '');

export const cerfaIssuer = z.object({
  id: z.guid(),
  name: z.string().trim().min(1, 'Donnez la raison sociale.').max(120),
  address: z.string().trim().max(200),
  siret: z.string().trim().max(17)
    .refine((value) => /^\d{14}$/.test(siretDigits(value)), 'SIRET incomplet : 14 chiffres attendus.'),
  /** Attestation de capacité de cette entreprise ; vide, celle de l'entreprise s'applique. */
  capacityCertificate: z.string().trim().max(100),
});
export type CerfaIssuer = z.infer<typeof cerfaIssuer>;

export const cerfaIssuers = z.array(cerfaIssuer).max(CERFA_ISSUERS_MAX)
  .refine((items) => new Set(items.map((item) => item.id)).size === items.length, 'Entreprise émettrice en double.');
